export const RESCHEDULE_CLASSES_PAGE_TRACKINGS = {
  confirmReschedule: 'confirm_reschedule',
};
